var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt--30"},[_c('v-col',{attrs:{"cols":"12"}},[_c('ul',{staticClass:"brand-style"},_vm._l((_vm.brandImages),function(brand,i){return _c('li',{key:i},[_c('a',{attrs:{"href":brand.url}},[_c('img',{attrs:{"src":brand.src,"alt":"Logo Images"}})])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }